export { getModeratedTags, getModerationId } from '@/libs/runtime-config/runtime-config';
